export default __webpack_public_path__ + "static/DREW_JONATHAN_RTG_LOGO_HORIZ_4C-4c9a5a03deaf73af921fe4f84fa3027d.png";